import { cn } from '@/lib/classNames';
import type { SortDir } from '@/lib/tableSort';

interface SortHeaderProps {
  label: string;
  /** This column's sort key. */
  field: string;
  /** The currently-active sort key. */
  activeField: string;
  dir: SortDir;
  onSort: (field: string) => void;
  className?: string;
}

/** A clickable, sortable table header cell with an asc/desc indicator. */
export function SortHeader({ label, field, activeField, dir, onSort, className }: SortHeaderProps) {
  const active = activeField === field;
  return (
    <th
      className={cn('ast-sortable', className)}
      onClick={() => onSort(field)}
      role="button"
      aria-sort={active ? (dir === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <span className="ast-sort-label">
        {label}
        <i className={cn('bi', active ? (dir === 'asc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill') : 'bi-arrow-down-up ast-sort-idle')} />
      </span>
    </th>
  );
}
